// 
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractHttp } from '../../../../../../core/classes/abstract-http';
import { environment } from '../../../../../../../environments/environment';

@Injectable()
export class ValidateFiscalCodeService extends AbstractHttp {
  constructor(http: HttpClient) {
   const url = `${environment.ENTORNO}${environment.SessionService.URL_General}${environment.SessionService.ENDPOINT.ValidateFiscalCode}`;
    super(http, url);
  }
}
